import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ALL_ROUTER_ICONS } from '@constants/route.constants';
import { ANALYTICS_SVG_ICONS, JRNI_MIGRATION_ICONS, SVG_ICONS, SVG_ICONS_LIST, SVG_WITH_PATH_ARRAY } from '@constants/svg-icons.constants';

@Injectable({
  providedIn: 'root'
})
export class IconService {

  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);

  registerCustomIcons(iconName: string, assetPath: string): void {
    this.iconRegistry.addSvgIcon(
      iconName,
      this.sanitizer.bypassSecurityTrustResourceUrl(assetPath)
    );
  }

  registerAllIcons() {
    this.registerSvgIconsList([...SVG_ICONS_LIST, ...ALL_ROUTER_ICONS]);
    const SVG_PATH_ARRAY_LIST = [...SVG_WITH_PATH_ARRAY, ...SVG_ICONS, ...ANALYTICS_SVG_ICONS, ...JRNI_MIGRATION_ICONS];
    this.registerSvgIconsList(SVG_PATH_ARRAY_LIST);
  }

  registerSvgIconsList(svgIcons: (string | { name: string; path?: string })[]): void {
    svgIcons.forEach((svgIcon: string | { name: string; path?: string; }) => {
      const path = ((typeof (svgIcon) === 'object') && svgIcon?.path) ? svgIcon?.path : `assets/images/icons/${svgIcon}.svg`;
      const name = ((typeof (svgIcon) === 'object') ? svgIcon.name : svgIcon);
      this.registerCustomIcons(`calio-${name}-icon`, path);
    });
  }
}
